export default "__VITE_ASSET__V0a8b8DB__"